//本目录只放置全站关于配置管理的js
export default {
    /** 配置管理插件：向 Vue 原型注入全局方法 */
    install(Vue, options) {
        /** 将数据以 JSON 字符串形式存入 localStorage */
        Vue.prototype.$setStorage = function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
            /** 从 localStorage 读取并反序列化为对象 */
            Vue.prototype.$getStorage = function (key) {
                let str = localStorage.getItem(key);
                if (str != "") {
                    return JSON.parse(localStorage.getItem(key));
                } else {
                    return []
                }
            },
            /** 移除 localStorage 中指定键的数据 */
            Vue.prototype.$removeStorage = function (key) {
                localStorage.removeItem(key);
            },
            /** 清空对象字段（可指定字段列表，默认清空全部）并返回原对象 */
            Vue.prototype.$delectObj = function (obj, array) {
                if (array) {
                    array.forEach(element => {
                        obj[element] = ""
                    });
                } else {
                    for (let key in obj) {
                        obj[key] = ''
                    }
                }
                return obj;
            },
            /** 将值转为整数 */
            Vue.prototype.$downToInteger = function (value) {
                return parseInt(value);

            },
            /** 判断按钮权限列表中是否包含指定资源路径 */
            Vue.prototype.$buttonAuthority = function (array, str) {
                let a = false
                if (array) {
                    if (array.length > 0) {
                        for (let index = 0; index < array.length; index++) {
                            const element = array[index];
                            if (element.resource_path == str) {
                                a = true
                                break;
                            }
                        }
                        return a;
                    } else {
                        return false

                    }
                } else {
                    return a
                }
            },
            /** 根据后端列描述生成表格列配置（含序号列与字典渲染） */
            Vue.prototype.$getTableLabel = function (array, obj) {
                let newArray = [];
                const param = {
                    label: "序号ID",
                    param: "xId",
                    align: "center",
                    width: "60",
                    show: true,
                };
                newArray.push(param);
                array.forEach((element) => {
                    if (element.render == 1 && element.renderType != 3) {
                        let param = {
                            label: element.keyValue,
                            param: element.keyName,
                            align: "center",
                            show: true,
                            render: (h, param) => {
                                const object = obj[element.keyName];
                                let spanStr = "";
                                for (const key in object) {
                                    if (object.hasOwnProperty(key)) {
                                        if (key == param.row[element.keyName]) {
                                            spanStr = object[key];
                                        }
                                    }
                                }
                                if (element.renderType == 0) {
                                    return h("span", spanStr);
                                }
                            },
                        };
                        if (element.renderType != 1) {
                            newArray.push(param);

                        }
                    } else {
                        let param = {
                            label: element.keyValue,
                            param: element.keyName,
                            align: "center",
                            show: true,
                        };
                        if (element.renderType == 3) {
                            param.type = "img"
                        }
                        if (element.renderType != 1) {
                            newArray.push(param);

                        }

                    }
                })
                return newArray;
            },
            /** 按值从对象中取对应键的文案（字典翻译） */
            Vue.prototype.$getText = function (num, object) {
                let Str = "";
                for (const key in object) {
                    if (object.hasOwnProperty(key)) {
                        const element = object[key];
                        if (num == key) {
                            Str = element
                        }

                    }
                }
                return Str
            }
        // 排序A-Z
        Vue.prototype.$sortAtoZ = function (array, obj) {
            let value = array.sort(function (s, t) {
                var a = s.toLowerCase();
                var b = t.toLowerCase();
                if (a < b) return -1;
                if (a > b) return 1;
                return 0;
            })
            let param = {}
            value.forEach(item => {
                for (const key in obj) {
                    const element = obj[key];
                    if (element == item) {
                        let strKey = key + " ";
                        param[strKey] = element;
                    }
                }
            });
            return param
        }
        /** 按换行拆分文本并去除空行与首尾空格 */
        Vue.prototype.$splitText = function (val) {
            let arr = val.split("\n");
            // 过滤掉为空以及处理前后有空格的数据
            let Str = arr.filter((item) => item != "").map((x) => x.trim());
            return Str
        }
    }
}
